import { useMemo } from 'react'

import { AppId } from '@inno-tools/container-bridge'
import { useAvailableApps } from 'modules/app-registry/hooks/useAvailableApps'
import { useUserContext } from 'shared/hooks'

import { WidgetAppTemplate } from '../../templates/WidgetAppTemplate'
import styles from './ClusterFoneCallWidgetApp.module.scss'

const ClusterFoneCallWidgetApp = () => {
  const { user } = useUserContext()
  const { apps } = useAvailableApps()

  const appProps = useMemo(() => ({ user }), [user])

  return (
    <div className={styles.root}>
      <WidgetAppTemplate
        user={user}
        scope='cluster_fone'
        envKey={apps[AppId.CLUSTER_FONE].runtimeEnvKey}
        entryPath='./CallWidget'
        url={process.env.REACT_APP_CLUSTER_FONE_APP_DEV_PATH}
        cdnUrl={apps[AppId.CLUSTER_FONE].cdnUrl}
        appProps={appProps}
        appName='ClusterFoneCallWidget'
      />
    </div>
  )
}

export { ClusterFoneCallWidgetApp }
